import axios from '@/util/axios';

const state = {
    count: 0
};

// getters
const getters = {
    count: (state) => state.count
};

// actions
const actions = {
    async refresh({ commit, rootGetters }) {
        var count = 0;

        if (rootGetters["user/isLoggedIn"]) {
            let currentConf = rootGetters["conference/current"];
            try {
                count = (await axios.get('public/conferences/conference/notifications/new/count', {
                    params: {
                        year: currentConf.year,
                        type: currentConf.type
                    }
                })).data;
            }
            finally { }
        }
        commit('setCount', count);
    },
}

// mutations
const mutations = {
    setCount(state, payload) {
        state.count = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}